import { data } from '../../svg/Workflow/data';
import { makeIcon } from '../makeIcon';

export const Workflow = makeIcon(data, 'workflow', 'Workflow');

export default Workflow;
